export const AUTH_STORAGE_KEYS = {
  account: 'blog_account',
  username: 'blog_username',
  accessToken: 'blog_token',
  refreshToken: 'blog_refresh_token',
};

export function readStoredSession() {
  return {
    account: localStorage.getItem(AUTH_STORAGE_KEYS.account) || '',
    username: localStorage.getItem(AUTH_STORAGE_KEYS.username) || '',
    accessToken: localStorage.getItem(AUTH_STORAGE_KEYS.accessToken) || '',
    refreshToken: localStorage.getItem(AUTH_STORAGE_KEYS.refreshToken) || '',
  };
}

export function hasStoredSession() {
  const session = readStoredSession();
  return !!session.account && !!session.accessToken;
}

export function clearStoredSession() {
  Object.values(AUTH_STORAGE_KEYS).forEach((key) => {
    localStorage.removeItem(key);
  });
}

export function getLoginRedirectUrl() {
  const base = import.meta.env.BASE_URL || '/';
  const currentPath =
    window.location.pathname + window.location.search + window.location.hash;
  const isLoginPage =
    window.location.pathname === '/login' ||
    window.location.pathname.endsWith('/login');

  if (isLoginPage || !currentPath || currentPath === '/') {
    return `${base}login`;
  }
  return `${base}login?redirect=${encodeURIComponent(currentPath)}`;
}

export function redirectToLogin() {
  window.location.assign(getLoginRedirectUrl());
}
